import Modal from 'components/Modal'
import LoyaltyRedemptionReversalTx from 'views/MemberProfile/ManualTx/LoyaltyRedemptionReversalTx'

type Props = {
  title: string | undefined
  open: boolean
  onClose: () => void
}

const ModalLoyaltyRedemptionReversal = ({
  title,
  open,
  onClose,
}: Props): JSX.Element => {
  return (
    <Modal open={open} title={title} onClose={onClose} noFooter>
      <LoyaltyRedemptionReversalTx onClose={onClose} />
    </Modal>
  )
}

export default ModalLoyaltyRedemptionReversal
